import React from 'react'
import UserForm from './UserForm'

class UserEdit extends React.Component {
  render(){
    const {user_id} = this.props.match.params
    return <UserForm actionName="update" user_id={user_id} headTitle="User"/>
  }
}

export default UserEdit



// WEBPACK FOOTER //
// ./src/js/components/UserEdit.js